/* Reducer USER */

const userJSON = localStorage.getItem("user")
const DEFAULT = userJSON ? JSON.parse(userJSON) : null

const user = (state = DEFAULT, action) => {

    switch (action.type) {

        case 'ADD_USER':
            localStorage.setItem("user", JSON.stringify(action.payload))
            return action.payload

        case 'UPDATE_USER':
            const updated = state ? { ...state, ...action.payload } : action.payload
            localStorage.setItem("user", JSON.stringify(updated))
            return updated

        case 'REMOVE_USER':
            localStorage.removeItem("user")
            return null

        default:
            return state
    }
}

export default user
